import { getApiUrlByEnvironment } from '@fitpet/constants-global'
import Axios, { AxiosError, AxiosRequestConfig } from 'axios'
import { isInAppFlag } from '@/utils/utilBridge'
import { localUserToken } from '@/utils/utilLocalStorage'

const getToken = () => {
  if (typeof window !== 'undefined' && isInAppFlag) {
    return window.getToken().apiToken.token === '' ? undefined : window.getToken().apiToken
  } else {
    return localUserToken.load()
  }
}

const userToken = getToken()

export const AXIOS_INSTANCE = Axios.create({
  baseURL: getApiUrlByEnvironment(process.env.NEXT_PUBLIC_ENVIRONMENT).mallRestLegacy,
  headers: {
    'content-type': 'application/json',
    Authorization: userToken !== undefined || userToken ? `Bearer ${userToken.token}` : null,
  },
})

export const customAxiosInstance = <T>(config: AxiosRequestConfig, options?: AxiosRequestConfig): Promise<T> => {
  const source = Axios.CancelToken.source()
  const promise = AXIOS_INSTANCE({
    ...config,
    ...options,
    cancelToken: source.token,
  }).then(({ data }) => data)

  // @ts-ignore
  promise.cancel = () => {
    source.cancel('Query was cancelled')
  }

  return promise
}

export type ErrorType<Error> = AxiosError<Error>
